import { createReducer, on } from '@ngrx/store';

import { CastActions, CastApiActions } from './cast.actions';
import { CastState } from './cast.models';

const initialState: CastState = {
    publicationListGuid: null,
};

export const castReducer = createReducer(
    initialState,
    on(CastActions.setCurrentPublicationListGuid, (state, action): CastState => {
        return {
            ...state,
            publicationListGuid: action.guid,
            processing: false,
            listLoading: false,
        };
    }),

    on(CastActions.setViewStates, (state, { viewStates }): CastState => {
        return {
            ...state,
            storedViewStates: viewStates,
        };
    }),
    on(CastActions.setCurrentViewState, (state, { guid }): CastState => {
        return {
            ...state,
            currentViewStateGuid: guid || null,
        };
    }),
    on(CastActions.setCurrentViewState, CastApiActions.reloadRecordsForSelectedViewState, CastApiActions.searchRecords, (state): CastState => {
        return {
            ...state,
            sideRecordsLoading: true,
        };
    }),
    on(CastActions.setSideRecordGuids, (state, { guids }): CastState => {
        return {
            ...state,
            sideRecordGuids: guids,
            sideRecordsLoading: false,
        };
    }),
    on(CastActions.stopSideRecordLoading, (state): CastState => {
        return {
            ...state,
            sideRecordsLoading: false,
        };
    }),
    on(CastActions.setDragRecordGuid, (state, { guid }): CastState => {
        return {
            ...state,
            dragRecordGuid: guid,
            draggingStarted: !!guid,
        };
    }),
    on(CastActions.stopDrag, (state): CastState => {
        return {
            ...state,
            draggingStarted: false,
        };
    }),
    on(CastApiActions.addUpdatePublicationList, CastApiActions.deleteSection, CastApiActions.deletePublications, CastApiActions.addPublicationsToPublicationListSection, (state): CastState => {
        return {
            ...state,
            processing: true,
        };
    }),
    on(CastApiActions.clearCurrentPublicationList, CastApiActions.publishCurrentPublicationList, (state): CastState => {
        return {
            ...state,
            listLoading: true,
            processing: true,
        };
    }),
    on(CastActions.setProcessing, (state, { processing }): CastState => {
        return {
            ...state,
            processing,
        };
    }),
    on(CastActions.setLoadingList, (state, { listLoading }): CastState => {
        return {
            ...state,
            listLoading,
        };
    }),
    on(CastActions.startAddingNewSection, (state, { position }): CastState => {
        return {
            ...state,
            newSectionPosition: position,
        };
    }),
    on(CastApiActions.addPublicationListSection, (state): CastState => {
        return {
            ...state,
            newSectionPosition: null,
        };
    }),
    on(CastActions.resetAddingNewSection, (state): CastState => {
        return {
            ...state,
            newSectionPosition: null,
        };
    })
);
